const PATH = 'fe.components.organization.editable_fields_group';

const messages = {
  save: {
    key: `${PATH}.save`,
    defaultValue: 'Save'
  },
  cancel: {
    key: `${PATH}.cancel`,
    defaultValue: 'Cancel'
  }
};

export default messages;
